import { render, staticRenderFns } from "./FormatSetup.vue?vue&type=template&id=1953ccb3&"
import script from "./FormatSetup.vue?vue&type=script&lang=ts&"
export * from "./FormatSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports